<template>
    <div class="ccapay-gocode">
          <div class="ccpay-gocode-header">
                <span @click="back"> 返回</span>
                <span >绑定谷歌</span>
                <span></span>
        </div>
        <div class="ccapay-gocode-connct">
            <p>打开谷歌验证器，扫描下方二维码或手动输入下述密钥添加验证令牌。</p>
            <p>密钥用于手机更换或遗失时找回谷歌验证器，绑定前请务必将下述密钥备份保存。</p>
       
        <div style="text-align:center; padding-top: 2rem;padding-bottom: 2rem;">
              <img style="width:120px;height:120px;object-fit: contain;" 
              v-lazy="`data:image/png;base64,${qrcode&&qrcode}`"
              :src="`data:image/png;base64,${qrcode&&qrcode}`"/>
            <!-- <div id="qrcode" ref="qrcode"></div> -->
        </div>
         <p>
            密钥：{{otpauth_url}}  <span
             class="tag-read" :data-clipboard-text="otpauth_url" 
             style="color:#20ABFE" @click="copy">复制</span>
         </p>
          <mt-field class="phoneNum phoneNumTull-lv"  
            style="border: 1px solid #ccc;margin-top: 1rem;"
           placeholder="验证码" type="tel" v-model="code"
                     
          ></mt-field>
          <mt-button class="mt-40" size="large" type="primary" 
                @click="band()">绑定</mt-button>
        </div>
    </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Indicator } from 'mint-ui';
// import QRCode from 'qrcodejs2'
export default {
    data(){
        return{
            code:'', //验证码
            otpauth_url:'',//密钥
            qrcode:'',//二维码
        }
    },
    mounted(){
        this.$axios.get('/v1/security/google/create').then(res=>{
           if(res.code==0){
               this.qrcode = res.data.generateQR
               this.otpauth_url = res.data.secret.base32
           }
        })
      
    },
    methods:{
        back(){
            this.$router.go(-1)
        },
         // 生成二维码
        crateQrcode (url) {
            console.log(111)
            this.qr = new QRCode('qrcode', {
            width: 150,
            height: 150, // 高度
            text: url // 二维码内容
            // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
            // background: '#f0f'
            // foreground: '#ff0'
            })
            console.log(this.qrcode)
        },
        copy(){
            var clipboard = new Clipboard('.tag-read')
                clipboard.on('success', e => {
                  console.log('复制成功')
                    this.$Toast('复制成功')
                  // 释放内存
                  clipboard.destroy()
                })
                clipboard.on('error', e => {
                  // 不支持复制
                  console.log('该浏览器不支持自动复制')
                  // 释放内存
                  clipboard.destroy()
                })
        },
        //绑定
        band(){
            if(this.code==''){
                 this.$Toast('请输入谷歌验证码')
                 return
            }
            Indicator.open();
            this.$axios.post('/v1/security/google/bind',{
                "code":this.code
            }).then(res=>{
                Indicator.close();
                if(res.code==0){
                     this.$Toast('绑定成功')
                     this.$router.go(-1)
                }else{
                     this.$Toast(res.msg)
                }
            })
        }
    }
}
</script>
<style>

</style>
<style lang="scss" scoped>
    .ccapay-gocode{
          background: white;
          height: 100%;;
        .ccpay-gocode-header{
            background: white;
            display: flex;
            justify-content: space-between;
            padding: 1rem;
        }
    }
    .ccapay-gocode-connct{
        padding: 1rem;
        p{
            line-height: 2rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/banggoogle/Googlecode.vue